<template>
  <header class="header" :class="{ 'fixed-header': isScrolled }">
    <div class="container">
      <div class="container-left">
        <div class="logo-area">
          <div class="logo">
            <img class="logo-img" :src="systemInfo.systemLogo ?  systemInfo.systemLogo : defaultAvatar" alt=""/>
          </div>
          <h1 class="company-name">{{ systemInfo.systemName || '深圳汇思益企业管理咨询有限公司' }}</h1>
        </div>

        <nav class="nav-menu">
          <div class="nav-menu-father" v-for="route in routes" :key="route.path">
            <div  :class="['nav-item', {active: $route.path === route.path}]" @click="handleMenuClick(route)" v-if="route.isMenu" :title="route.meta.title">
              {{ handleChara(route.meta.title,7) }}
            </div>
            <div class="nav-menu-special" v-else :title="route.meta.title">
              {{ handleChara(route.meta.title,7) }}
              <!-- 下拉菜单 -->
              <div class="nav-menu-list">
                <div class="arrow"></div>
                <div class="contact-info-item" @click="handleSkip(item.productLink)" v-for="item in  productList" :key="item.id">
                  {{item.productName}}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="contact-info">
        <img class="phone-img" :src="isScrolled ? phone_v1 : phone" alt="电话"/>
        <div class="phone">400-600-0115</div>
      </div>
    </div>
  </header>
</template>

<script setup>
import {computed, ref, onMounted, onUnmounted} from 'vue'
import {useRouter} from 'vue-router'
import defaultAvatar from '@/assets/images/avatar.gif'
import {getMenuList, getSystemInfo} from "@/api/apiHome";
import {getProductList} from "@/api/apiProduct";
import phone from "@/assets/images/phone.png";
import phone_v1 from "@/assets/images/phone_v1.png";
import {generateMenuFromBackend} from "@/utils/menu";
import {handleChara} from "@/utils/title";
import {emitter} from "@/eventBus/eventBus";
const router = useRouter()
const isScrolled = ref(false) // 用于跟踪页面是否滚动
const systemInfo = ref({})
const productList=ref([])
const menuList=ref([])
// 获取路由信息用于导航菜单
const routes = computed(() => {
  return menuList.value.filter(route => route.isShow)
})
// 处理滚动事件的函数
const handleScroll = () => {
  // 当滚动超过50px时，认为是已滚动状态
  isScrolled.value = window.scrollY > 50
}
// 处理菜单点击
const handleMenuClick = (menuItem) => {
  const {path } = menuItem
  router.push(path)
}
// 挂载时添加滚动监听
onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

// 卸载时移除滚动监听
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
const handleSkip = (url) => {
  window.open(url, '_blank')
}
const querySystemInfo = async () => {
  const {code, data} = await getSystemInfo();
  if (code === 200) {
    systemInfo.value = data
    emitter.emit('systemInfo',data)
  }
}
const queryProductList=async ()=>{
   const {code, data}=await getProductList()
  if (code === 200) {
    productList.value = data?.length>10 ? data.slice(0,10) : data;
  }
}
//获取菜单
const queryMenuList=async ()=>{
  const {code, data}=await getMenuList()
  if (code === 200) {
    menuList.value = generateMenuFromBackend(data)
  }
}
queryProductList()
querySystemInfo()
queryMenuList()
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* 确保菜单在其他内容上方 */
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 50px;
  box-sizing: border-box;
  height: 60px;
}

.container-left {
  display: flex;
}

.logo-area {
  display: flex;
  align-items: center;
}

.logo {
  width: 43px;
  height: 43px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  border-radius: 5px;
  margin-right: 14px;
}

.logo-img {
  width: 100%;
}

.company-name {
  font-size: 20px;
  color: #FFFFFF;
  min-width: 100px;
}

.nav-menu {
  display: flex;
  gap: 50px;
  align-items: center;
  margin-left: 90px;
}
.nav-menu-father{

}
.nav-item {
  text-decoration: none;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  border-radius: 4px;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  cursor: pointer;
  min-width: 50px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

/* 下划线动画效果 */
.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translateX(-50%);
  width: 36px;
  height: 3px;
  background: #FFFFFF;
  border-radius: 2px;
  transition: all 0.3s ease;
}
/* 滚动后的固定样式 */
.fixed-header {
  background-color: #fff; /* 滚动后恢复的背景色 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 添加阴影增强层次感 */
  .nav-item, .nav-menu-special, .company-name {
    color: #000;
  }
  .phone{
    color: #000 !important;
  }
  .nav-item.active {
    color: #0048A9;
  }
  .nav-item.active::after {
    background-color: #0048A9;
  }
}

.contact-info {
  display: flex;
  align-items: center;
  width: 147px;
  height: 40px;
}

.contact-info .phone {
  margin-left: 5px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
}

.phone-img {
  width: 14px;
  height: 14px;
}

.nav-menu-special {
  position: relative;
  text-decoration: none;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  border-radius: 4px;
  cursor: pointer;
  min-width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

/* 下拉菜单样式 */
.nav-menu-list {
  display: none;
  position: absolute;
  top: 40px;
  left: -57px;
  width: 240px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 1001;
  padding: 15px 20px 20px 20px;
  box-sizing: border-box;
}

/* 三角符号样式 */
.arrow {
  position: absolute;
  top: -7px; /* 定位到菜单顶部 */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff; /* 与菜单背景色一致 */
}

/* 添加阴影过滤（可选） */
.arrow::after {
  content: '';
  position: absolute;
  top: 1px;
  left: -10px;
  border-bottom: 10px solid #ddd; /* 与边框颜色一致 */
  z-index: -1;
}
/* 悬浮触发显示 */
.nav-menu-special:hover .nav-menu-list {
  display: block;
}

/* 下拉菜单项样式 */
.contact-info-item {
  font-size: 14px;
  color: #242424;
  cursor: pointer;
  line-height: 38px;
  text-align: left;
  font-style: normal;
  font-weight: bold;
  transition: background 0.3s;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.contact-info-item:hover{
  color: #0048A9;
}
</style>
